<template>

  <div class="pr-15 pb-10" v-if="myVoicemail">

    <h2 class="form-section-heade ml-0 mb-0">
      Voicemail Settings
    </h2>
    <p class="black-text mt-0 mb-0">
      This allows you to change voicemail settings and manage your voicemail greetings to inform callers of your status.
    </p>
    <el-form style="margin-top: 0;">
      <el-input
        style="margin-left: 0;"
        maxlength="4"
        v-model="vmPin"
        placeholder="Enter PIN"
      >
        <template slot="prefix">
          Voicemail PIN
        </template>
      </el-input>
      <el-input
        style="margin-left: 0;"
        v-model="vmEmail"
        placeholder="Enter Email"
      >
        <template slot="prefix">
          Voicemail Email
        </template>
      </el-input>
      <el-button
        type="primary"
        @click="updateVmBox"
      >
        Save
      </el-button>
    </el-form>

    <div id="name-greeting-container" class="pr-20">
      <h2 class="mb-0">
        Name Greeting
      </h2>
      <p class="black-text mt-5 mb-5">
        This plays to identify your extension
      </p>
      <voicemail-greeting
        :existingGreeting="nameGreeting"
        defaultName="name_greeting.wav"
        recordedName="name_greeting.webm"
        dirFolder="greeting"
        @greetingSaved="updateNameGreeting"
        @greetingRemoved="removeNameGreeting"
      >
      </voicemail-greeting>
      <hr class="mt-20">
    </div>


    <div id="unavailable-greeting-container" class="pr-20">
      <h2 class="mb-0">
        Unavailable Greeting
      </h2>
      <p class="black-text mt-5 mb-5">
        This plays when you do not pick up the phone
      </p>
      <voicemail-greeting
        :existingGreeting="unavailGreeting"
        defaultName="unavail_greeting.wav"
        recordedName="unavail_greeting.webm"
        dirFolder="unavailable"
        @greetingSaved="updateUnavailGreeting"
        @greetingRemoved="removeUnavailGreeting"
      >
      </voicemail-greeting>
      <hr class="mt-20">
    </div>

    <div id="busy-greeting-container" class="pr-20">
      <h2 class="mb-0">
        Busy Greeting
      </h2>
      <p class="black-text mt-5 mb-5">
        This plays when you are on the phone
      </p>
      <voicemail-greeting
        :existingGreeting="busyGreeting"
        defaultName="busy_greeting.wav"
        recordedName="busy_greeting.webm"
        dirFolder="busy"
        @greetingSaved="updateBusyGreeting"
        @greetingRemoved="removeBusyGreeting"
      >
      </voicemail-greeting>
      <hr class="mt-20">
    </div>



    <div id="temporary-greeting-container" class="pr-20">
      <h2 class="mb-0">
        Out of Office Greeting
      </h2>
      <el-checkbox v-model="tempEnabled" v-if="tempGreeting" style="display: inline-block;">
        Enable Out of Office Greeting
      </el-checkbox>
      <p class="black-text mt-5 mb-5">
        This overrides your unavailable and busy greetings
      </p>
      <voicemail-greeting
        :existingGreeting="tempGreeting"
        defaultName="out_of_office_greeting.wav"
        recordedName="out_of_office_greeting.webm"
        dirFolder="temporary"
        :tempEnabled="tempEnabled"
        @greetingSaved="updateTempGreeting"
        @greetingRemoved="removeTempGreeting"
      >
      </voicemail-greeting>
    </div>
  </div>
  <div v-else>
    <p>
      Your extension does not have a configured voicemail box. Contact an administrator for support.
    </p>
  </div>

</template>

<script>

import feathersClient from '@/feathers/feathers-client';
import voicemailGreeting from '../components/voicemail-greeting';
import debounce from 'lodash/debounce';

  export default {
    name: 'VoicemailSettings',
    components: {voicemailGreeting},
    data(){
      return {
        nameGreeting: null,
        busyGreeting: null,
        unavailGreeting: null,
        tempGreeting: null,
        tempEnabled: false,
        greetingAudioElement: null,
        myVoicemail: null,
        vmPin: '',
        vmEmail: ''
      }
    },
    computed: {
      user() {
        return this.$store.state.auth.user;
      }
    },
    watch: {
      tempEnabled: debounce(function () {
        if(this.tempGreeting){
          this.toggleTempGreeting();
        }
      }, 500)
    },
    methods: {
      queryGreetings(){
        feathersClient.service('voicemail-messages').find({
          query: {
            msgNum: -1,
            mailboxuser: this.user.myExtension.number,
            mailboxContext: this.user.myExtension.tenantCode
          }
        }).then( (res) => {

          //figure out which greetings are which
          for(let i = 0; i < res.length; i++){
            const currentGreeting = res[i];
            const greetingSplit = currentGreeting.dir.split('/');
            const splitLength = greetingSplit.length;

            const vmType = greetingSplit[splitLength - 1];

            if(vmType === 'unavail'){
              this.unavailGreeting = currentGreeting;
              continue;
            }
            if(vmType === 'greet'){
              this.nameGreeting = currentGreeting;
              continue;
            }
            if(vmType === 'temp' || vmType === 'temp_deleted'){
              this.tempGreeting = currentGreeting;
              this.tempEnabled = vmType === 'temp';
              continue;
            }
            if(vmType === 'busy'){
              this.busyGreeting = currentGreeting;
            }
          }
        });
      },
      queryVoicemail(){
        feathersClient.service('voicemails').find({
          query: {
            mailbox: this.user.myExtension.number,
            tenantId: this.user.myExtension.tenantId
          }
        }).then( res => {
          if(res.length){
            this.myVoicemail = res[0];
            this.vmPin = res[0].password;
            this.vmEmail = res[0].email;
          }
        })
      },
      toggleTempGreeting(){
        const dirPath = this.tempEnabled ? 'temp' : 'temp_deleted';
        feathersClient.service('voicemail-messages').patch(this.tempGreeting.id, {
          dir: `/var/spool/asterisk/voicemail/${this.user.myExtension.tenantCode}/${this.user.myExtension.number}/${dirPath}`,
          mailboxuser: this.user.myExtension.number,
          mailboxContext: this.user.myExtension.tenantCode
        });
      },
      updateNameGreeting(payload){
        this.nameGreeting = payload;
      },
      updateBusyGreeting(payload){
        this.busyGreeting = payload;
      },
      updateUnavailGreeting(payload){
        this.unavailGreeting = payload;
      },
      updateTempGreeting(payload){
        this.tempGreeting = payload;
        this.tempEnabled = true;
      },
      removeNameGreeting(){
        this.nameGreeting = null;
      },
      removeBusyGreeting(){
        this.busyGreeting = null;
      },
      removeUnavailGreeting(){
        this.unavailGreeting = null;
      },
      removeTempGreeting(){
        this.tempGreeting = null;
        this.tempEnabled = false;
      },
      updateVmBox(){
       feathersClient.service('voicemails').patch(this.myVoicemail.id, {
          onlyCredentials: true,
          password: this.vmPin,
          email: this.vmEmail
       }).then( () => {
         this.$notify({
           type: 'success',
           title: 'Changes Saved',
           message: 'Your PIN and Email Were Successfully Updated!'
         })
       });
      }
    },
    created(){
      this.queryVoicemail();
      this.queryGreetings();
    }
  };

</script>

<style lang="scss">

  .vue-audio-recorder{
    width: 40px !important;
    height: 40px !important;
    background-color: #ef5350 !important;
  }

  .current-greeting-container{
    height: 35px;
  }

  #greeting-play-button{
    width: 55px;
    height: 55px;
    i{
      font-size: 2em;
    }
  }

</style>
